import React from 'react'
import { MultiSelect } from 'primereact/multiselect'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export const TagsMultiselect = (props) => {
    const { setSelectedMultiTag, selectedMultiTag, options = [], className = "", style = {} } = props;

    const { t } = useTranslation("common");

    //redux states
    const { tags } = useSelector((state) => state.businessCustomers)

    const fallbackOptions = (tags || [])
        .filter((tag) => tag?.id && tag?.name)
        .map((tag) => ({ label: tag.name, value: tag.id }));

    const resolvedOptions = options?.length ? options : fallbackOptions;

    return (
        <div className="mt-3">
            <p className="labels">{t("tags.tag_select")}</p>
            <MultiSelect
                id="tag_select"
                placeholder={t("tags.choose_tag")}
                options={resolvedOptions}
                optionLabel="label"
                optionValue="value"
                optionGroupLabel="label"
                optionGroupChildren="items"
                value={selectedMultiTag}
                onChange={(e) => setSelectedMultiTag(e?.value)}
                className={`multi_tag_select ${className}`.trim()}
                style={style}
                display="chip"
                showSelectAll={false}
            >
            </MultiSelect>
        </div>
    )
}
